import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import { enrollmentSentence } from 'app/lib/workflows/activationSummary'
import { triggerDisplayLabel, triggerIcon, triggerSummary } from 'app/lib/workflows/triggerCatalog'
import type { TriggerFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Entry point. Enrolls a contact when the configured trigger fires. No incoming handle. The card
 *  reads the configured trigger back as one generated sentence once conditions exist (design
 *  language rule 8: read-back lives on the card, not as prose in the panel). */
export function TriggerNode({ data, selected }: NodeProps<TriggerFlowNode>) {
  const copy = useListCopy()
  const description = data.conditions?.length ? enrollmentSentence(data) : (data.summary ?? triggerSummary(data.kind))
  return (
    <NodeShell
      icon={triggerIcon(data.kind)}
      accent="emerald"
      kind="Trigger"
      label={triggerDisplayLabel(data, copy)}
      description={description}
      selected={selected}
      hasTarget={false}
    />
  )
}
